document.addEventListener('DOMContentLoaded', () => {
    const wishlistGrid = document.getElementById('wishlist-grid');
    const wishlistEmpty = document.getElementById('wishlist-empty');
    const wishlistCount = document.getElementById('wishlist-count');

    let currentCart = null;

    // ── Storage helpers delegate to window.EngoodWishlist (set by product-card-wishlist.js)
    // This ensures wishlist-template.js always reads from the same customer-namespaced key.
    function getWishlist() {
        // EngoodWishlist is guaranteed to be loaded before this script (loaded globally in theme.liquid)
        if (window.EngoodWishlist) return window.EngoodWishlist.getWishlist();
        // Fallback: plain guest key (should never reach here in normal operation)
        try { return JSON.parse(localStorage.getItem('engood-wishlist-guest')) || []; } catch { return []; }
    }

    function saveWishlist(wishlist) {
        if (window.EngoodWishlist) {
            window.EngoodWishlist.saveWishlist(wishlist);
        } else {
            try { localStorage.setItem('engood-wishlist-guest', JSON.stringify(wishlist)); } catch { /* ignore */ }
        }
    }

    // Show localStorage-unavailable warning (incognito wipe risk)
    function maybeShowStorageWarning() {
        if (window.EngoodWishlist && !window.EngoodWishlist.isStorageAvailable()) {
            const banner = document.getElementById('wishlist-storage-warning');
            if (banner) banner.classList.remove('hidden');
        }
    }

    function announceStatus(message) {
        const statusEl = document.getElementById('wishlist-status');
        if (statusEl) {
            statusEl.textContent = message;
        }
    }

    // Remove item from wishlist
    function removeFromWishlist(productHandle) {
        let wishlist = getWishlist();
        const removedItem = wishlist.find((item) => item.handle === productHandle);
        const title = removedItem ? removedItem.title : 'Item';
        wishlist = wishlist.filter((item) => item.handle !== productHandle);
        saveWishlist(wishlist);
        renderWishlist();
        announceStatus(`"${title}" removed from wishlist.`);
        window.dispatchEvent(new CustomEvent('wishlist-updated', { detail: { wishlist } }));
    }

    // Find cart item by variant ID
    function findCartItem(variantId) {
        if (!currentCart || !currentCart.items) return null;
        return currentCart.items.find((item) => String(item.variant_id) === String(variantId));
    }

    // Render wishlist items
    async function renderWishlist() {
        const wishlist = getWishlist();
        wishlistCount.textContent = wishlist.length;
        wishlistCount.classList.remove('opacity-0');

        // Fetch current cart
        if (window.EngoodCart) {
            currentCart = await window.EngoodCart.getCart();
        }

        if (wishlist.length === 0) {
            wishlistGrid.innerHTML = '';
            wishlistGrid.classList.add('hidden');
            wishlistEmpty.classList.remove('hidden');
            wishlistEmpty.classList.add('flex');
            return;
        }

        // Fetch live prices (M1) to prevent stale data
        const fetchPromises = wishlist.map(async (item) => {
            if (window.engoodPriceCache && window.engoodPriceCache[item.handle]) {
                item.livePrice = window.engoodPriceCache[item.handle];
                return;
            }
            try {
                const res = await fetch(`/products/${item.handle}.js`);
                if (!res.ok) throw new Error('Not found');
                const productData = await res.json();
                const variant = productData.variants.find((v) => String(v.id) === String(item.variantId)) || productData.variants[0];
                const livePrice = window.formatMoney ? window.formatMoney(variant.price) : `$${(variant.price / 100).toFixed(2)}`;
                
                window.engoodPriceCache = window.engoodPriceCache || {};
                window.engoodPriceCache[item.handle] = livePrice;
                item.livePrice = livePrice;
            } catch (e) {
                console.error(`Failed to fetch live price for ${item.handle}`);
                item.livePrice = item.price; // fallback to stored price
            }
        });

        await Promise.all(fetchPromises);

        wishlistGrid.classList.remove('hidden');
        wishlistEmpty.classList.add('hidden');
        wishlistEmpty.classList.remove('flex');

        wishlistGrid.innerHTML = wishlist
            .map((item, index) => {
                const cartItem = findCartItem(item.variantId);
                const inCart = !!cartItem;

                return `
      <div
        class="group flex flex-col h-full bg-white rounded-xl md:rounded-2xl overflow-hidden border border-[#e9f1e9] transition-all duration-300 lg:hover:shadow-2xl lg:hover:-translate-y-2 active:scale-[0.98] product-card"
        data-handle="${item.handle}"
        data-variant-id="${item.variantId}"
      >
        <a href="${item.url}" class="block relative overflow-hidden bg-[#f4f4f4] aspect-square">
          <img
            src="${item.image}"
            alt="${item.title}"
            class="w-full h-full object-cover transition-transform duration-500 ease-out lg:group-hover:scale-105"
            loading="${index < 4 ? 'eager' : 'lazy'}"
          >

          <!-- Wishlist Heart (filled, since it's in wishlist) (L1) -->
          <button
            class="wishlist-remove absolute top-3 left-3 md:top-4 md:left-4 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/60 backdrop-blur-md flex items-center justify-center shadow-md transition-all duration-300 hover:scale-110 hover:bg-white/90 z-10"
            data-handle="${item.handle}"
            aria-label="Remove from wishlist"
          >
            <span class="material-symbols-outlined text-[18px] md:text-[20px] text-red-500">favorite</span>
          </button>
        </a>

        <div class="p-3 md:p-6 flex flex-col flex-1 h-full">
          <h3 class="text-text-main text-sm md:text-lg font-display font-bold leading-snug mb-1 md:mb-2">
            <a href="${item.url}" class="transition-colors hover:text-primary line-clamp-2">${item.title}</a>
          </h3>

          <div class="flex flex-col gap-0.5 md:gap-1 mb-2 md:mb-4">
            <span class="text-primary font-extrabold text-base md:text-xl">${item.livePrice}</span>
          </div>

          <!-- Action Wrapper -->
          <div class="mt-auto product-card-action-wrapper" data-variant-id="${item.variantId}">
            ${item.hasOnlyDefaultVariant === false
                        ? `
              <a
                href="${item.url}"
                class="w-full bg-white border border-primary hover:bg-primary/5 text-primary font-bold py-2 md:py-3 px-3 md:px-6 rounded-lg md:rounded-xl transition-all duration-200 flex items-center justify-center gap-2 shadow-sm h-10 md:h-12"
              >
                <span class="material-symbols-outlined text-[18px] md:text-[20px]">visibility</span>
                <span class="text-sm md:text-base">View Options</span>
              </a>
            `
                        : inCart
                        ? `
              <div
                class="flex items-center justify-between w-full rounded-xl overflow-hidden bg-primary/10 h-10 md:h-11 p-0.5"
                data-item-key="${cartItem.key}"
              >
                <button
                  type="button"
                  data-qty="${cartItem.quantity - 1}"
                  class="wishlist-qty-btn w-9 md:w-10 h-full flex items-center justify-center text-primary font-bold transition-all shrink-0 hover:bg-primary/20 active:bg-primary/30"
                  aria-label="Decrease quantity"
                >
                  <span class="material-symbols-outlined text-[18px]">remove</span>
                </button>

                <div class="flex-1 h-full bg-white flex items-center justify-center relative px-3 min-w-0 rounded-sm">
                  <span class="font-extrabold text-text-main text-sm md:text-base font-body">${cartItem.quantity}</span>
                </div>

                <button
                  type="button"
                  data-qty="${cartItem.quantity + 1}"
                  class="wishlist-qty-btn w-9 md:w-10 h-full flex items-center justify-center text-primary font-bold transition-all shrink-0 hover:bg-primary/20 active:bg-primary/30"
                  aria-label="Increase quantity"
                >
                  <span class="material-symbols-outlined text-[18px]">add</span>
                </button>
              </div>
            `
                        : `
              <button
                type="button"
                data-add="1"
                data-variant-id="${item.variantId}"
                class="wishlist-add-btn w-full bg-primary hover:bg-[#1a6b1a] text-white font-bold py-2 md:py-3 px-3 md:px-6 rounded-lg md:rounded-xl transition-all duration-200 flex items-center justify-center gap-2 shadow-md h-10 md:h-12"
                aria-label="Add to cart"
              >
                <span class="material-symbols-outlined text-[18px] md:text-[20px]">add_shopping_cart</span>
                <span class="text-sm md:text-base">Add to Cart</span>
              </button>
            `
                    }
          </div>
        </div>
      </div>
    `;
            })
            .join('');

        // Attach event listeners
        attachEventListeners();
    }

    const undoTimers = {};

    function showUndoToast(productHandle, productTitle, row) {
        const UNDO_DELAY = 5000;

        // Visually fade the row immediately to signal removal
        if (row) {
            row.style.transition = 'opacity 0.3s, transform 0.3s';
            row.style.opacity = '0.3';
            row.style.pointerEvents = 'none';
        }

        // Remove any existing toast for this handle
        const existingToast = document.getElementById(`wishlist-undo-toast-${productHandle}`);
        if (existingToast) existingToast.remove();
        if (undoTimers[productHandle]) clearTimeout(undoTimers[productHandle]);

        // Build the toast
        const toast = document.createElement('div');
        toast.id = `wishlist-undo-toast-${productHandle}`;
        toast.setAttribute('role', 'alert');
        toast.className = [
            'fixed bottom-24 left-1/2 -translate-x-1/2',
            'flex items-center gap-3',
            'bg-gray-900 text-white text-sm font-medium',
            'px-4 py-3 rounded-xl shadow-2xl z-[300]',
            'opacity-0 translate-y-4 transition-all duration-300',
            'w-[calc(100vw-2rem)] max-w-sm'
        ].join(' ');

        // Progress bar countdown
        toast.innerHTML = `
            <span class="material-symbols-outlined text-red-400 shrink-0">favorite_border</span>
            <span class="flex-1 truncate text-left">"${productTitle}" removed</span>
            <button
                id="wishlist-undo-btn-${productHandle}"
                class="shrink-0 bg-primary text-white font-bold text-xs px-3 py-1.5 rounded-lg hover:bg-[#1a6b1a] transition-colors focus:outline-none focus:ring-2 focus:ring-primary"
                aria-label="Undo remove ${productTitle}"
            >Undo</button>
            <div class="absolute bottom-0 left-0 h-0.5 bg-primary rounded-full transition-none" id="wishlist-undo-progress-${productHandle}" style="width: 100%"></div>
        `;

        document.body.appendChild(toast);

        // Animate in
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                toast.classList.remove('opacity-0', 'translate-y-4');
                // Kick off progress bar shrink
                const progressBar = document.getElementById(`wishlist-undo-progress-${productHandle}`);
                if (progressBar) {
                    progressBar.style.transition = `width ${UNDO_DELAY}ms linear`;
                    progressBar.style.width = '0%';
                }
            });
        });

        // Undo button handler
        const undoBtn = document.getElementById(`wishlist-undo-btn-${productHandle}`);
        undoBtn?.addEventListener('click', () => {
            clearTimeout(undoTimers[productHandle]);
            delete undoTimers[productHandle];

            // Restore row visibility
            if (row) {
                row.style.opacity = '1';
                row.style.pointerEvents = '';
            }

            announceStatus(`"${productTitle}" restored to wishlist.`);

            // Dismiss toast
            toast.classList.add('opacity-0', 'translate-y-4');
            setTimeout(() => toast.remove(), 300);
        });

        // Schedule the actual remove after delay
        undoTimers[productHandle] = setTimeout(() => {
            delete undoTimers[productHandle];

            // Dismiss toast
            toast.classList.add('opacity-0', 'translate-y-4');
            setTimeout(() => toast.remove(), 300);

            // Fully fade out the row, then call the remove
            if (row) {
                row.style.opacity = '0';
                row.style.transform = 'scale(0.95)';
            }

            removeFromWishlist(productHandle);
        }, UNDO_DELAY);
    }

    // Attach all event listeners
    function attachEventListeners() {
        // Remove from wishlist (heart click)
        document.querySelectorAll('.wishlist-remove').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const handle = btn.dataset.handle;
                const row = btn.closest('.product-card');
                const titleElement = row?.querySelector('h3 a');
                const title = titleElement ? titleElement.textContent.trim() : 'Item';
                
                showUndoToast(handle, title, row);
            });
        });

        // Add to cart
        document.querySelectorAll('.wishlist-add-btn').forEach((btn) => {
            btn.addEventListener('click', async () => {
                const variantId = btn.dataset.variantId;
                const card = btn.closest('.product-card');
                const title = card?.querySelector('h3 a')?.textContent.trim() || 'Item';
                btn.disabled = true;
                btn.innerHTML =
                    '<span class="material-symbols-outlined text-[18px] animate-spin">progress_activity</span> Adding...';

                try {
                    if (window.EngoodCart) {
                        await window.EngoodCart.add(variantId, 1);
                        // Re-render to show quantity selector
                        await renderWishlist();
                        announceStatus(`"${title}" added to cart.`);
                        // Open cart drawer for immediate conversion confirmation (M3)
                        if (typeof openCartDrawer === 'function') {
                            openCartDrawer();
                        }
                    }
                } catch (error) {
                    console.error('Error adding to cart:', error);
                    btn.disabled = false;
                    btn.innerHTML =
                        '<span class="material-symbols-outlined text-[18px] md:text-[20px]">add_shopping_cart</span><span class="text-sm md:text-base">Add to Cart</span>';
                }
            });
        });

        // Quantity adjustment buttons
        document.querySelectorAll('.wishlist-qty-btn').forEach((btn) => {
            btn.addEventListener('click', async () => {
                const wrapper = btn.closest('[data-item-key]');
                if (!wrapper) return;

                const key = wrapper.dataset.itemKey;
                const newQty = parseInt(btn.dataset.qty);
                const card = btn.closest('.product-card');
                const title = card?.querySelector('h3 a')?.textContent.trim() || 'Item';

                // 🛡️ GUARD: Max quantity validation (H3)
                if (newQty > 99) {
                    if (window.EngoodCart && typeof window.EngoodCart.showMaxLimitToast === 'function') {
                        window.EngoodCart.showMaxLimitToast(99);
                    }
                    return;
                }

                // Disable buttons during update
                wrapper.querySelectorAll('button').forEach((b) => (b.disabled = true));

                try {
                    if (window.EngoodCart) {
                        await window.EngoodCart.change(key, newQty);
                        // Re-render to update quantity or show "Add to Cart" if qty becomes 0
                        await renderWishlist();
                        if (newQty === 0) {
                            announceStatus(`"${title}" removed from cart.`);
                        } else {
                            announceStatus(`"${title}" quantity updated to ${newQty}.`);
                        }
                    }
                } catch (error) {
                    console.error('Error updating cart:', error);
                    wrapper.querySelectorAll('button').forEach((b) => (b.disabled = false));
                }
            });
        });
    }

    // Initial render
    renderWishlist();
    maybeShowStorageWarning();

    // Show guest notice if guest has items (C1)
    const guestNotice = document.getElementById('wishlist-guest-notice');
    if (guestNotice && getWishlist().length > 0) {
        guestNotice.classList.remove('hidden');
        guestNotice.classList.add('flex');
    }

    // Listen for wishlist updates from other pages
    window.addEventListener('wishlist-updated', renderWishlist);

    // Listen for cart updates to re-render (sync quantity selectors)
    window.addEventListener('cart-updated', renderWishlist);

    // Listen for optimistic item removal (H4)
    window.addEventListener('item-removed', (e) => {
        if (currentCart && currentCart.items) {
            const key = e.detail.itemKey;
            // Optimistically remove from local state
            currentCart.items = currentCart.items.filter((item) => item.key !== key);
            // Re-render instantly, restoring the "Add to Cart" button
            renderWishlist();
        }
    });
});